import { TriangleAlertIcon, Trash2Icon } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';

export type RemoveDomainModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  domain: string;
  isRemoving?: boolean;
  onConfirm: () => void;
};

export function RemoveDomainModal({
  open,
  onOpenChange,
  domain,
  isRemoving,
  onConfirm,
}: RemoveDomainModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Remove {domain}</DialogTitle>
        </DialogHeader>
        <div className="flex items-start gap-3 rounded-lg border border-rose-200 bg-rose-50 px-4 py-3">
          <TriangleAlertIcon className="mt-0.5 size-4 shrink-0 text-destructive" />
          <div className="flex flex-1 flex-col gap-1 text-sm text-destructive">
            <span className="font-medium">
              The custom URLs of your pages will stop working.
            </span>
            <span>
              Every page stays live on its tinct URL — only the{' '}
              <span className="font-mono text-xs">{domain}</span> links go dead.
            </span>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            isLoading={isRemoving}
          >
            <Trash2Icon className="size-4" />
            Remove domain
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
